export const DESIGN_VARIANTS = [
  'normal',
  'slim',
  'xs',
  'pill',
  'greypill',
  'ruesSearchbar',
  'searchresultSearchbar',
  ''
] as const

export type DesignVariant = typeof DESIGN_VARIANTS[number]

export const isDesignVariant = (value: string): value is DesignVariant =>
  (DESIGN_VARIANTS as readonly string[]).includes(value)
